export class User {
  _id = '';
  _username = '';
  _name = '';
  _email = '';
  _lastName = '';
  _token = '';

  constructor(
    id,
    username,
    name,
    email,
    lastName,
    token,
  ) {
    this._id = id || '';
    this._username = username || '';
    this._name = name || '';
    this._email = email || '';
    this._lastName = lastName || '';
    this._token = token || '';
  }

  get id() {
    return this._id;
  }

  get username() {
    return this._username;
  }

  get name() {
    return this._name;
  }

  get email() {
    return this._email;
  }

  get lastName() {
    return this._lastName;
  }

  get fullName() {
    return `${this._name} ${this._lastName}`;
  }

  get token() {
    return this._token;
  }

  get isLogged() {
    return this._token !== '';
  }

  login(user) {
    this._id = user.id || '';
    this._username = user.username || '';
    this._name = user.name || '';
    this._email = user.email || '';
    this._lastName = user.lastName || '';
    this._token = user.token || '';
  }

  logout() {
    this._id = '';
    this._username = '';
    this._name = '';
    this._email = '';
    this._lastName = '';
    this._token = '';
  }

  static fromJson(json) {
    return new User(
      json.id,
      json.username,
      json.name,
      json.email,
      json.lastName,
      json.token,
    );
  }

  toJson() {
    return {
      id: this._id,
      username: this._username,
      name: this._name,
      email: this._email,
      lastName: this._lastName,
      token: this._token,
    };
  }
}